export const DEFAULT_SELF_ADS_PILL_MESSAGES = [
  "Did you know? Knoot can screen hundreds of resumes like this in seconds",
  "Fun fact: Knoot enables transparent, shared insights between recruiters",
  "Pro tip: Knoot is an AI-first hiring system with a comprehensive status pipeline",
  "Good to know: Knoot can create job postings tailored to any hiring need",
  "Here's something cool: Knoot helps you manage thousands of candidates with AI-backed pipelines",
  "Quick insight: Knoot can score and organize job descriptions automatically",
  "Worth knowing: Knoot can deliver visual AI reports that screen hundreds of applicants at once",
  "Heads up: Knoot can switch between hiring projects in seconds",
  "Pro tip: Knoot's template system helps you tailor job postings to your company's branding",
  "Smart move: Knoot explains why each candidate fits—not just a score on a page",
  "Bonus: your whole team can review the same shortlist without spreadsheet chaos",
  "Sneak peek: Knoot turns messy CV piles into ranked shortlists before lunch",
  "Level up: search your entire talent database with AI, not keyword bingo",
  "Nice touch: share hiring insights across recruiters without endless Slack threads",
  "Real talk: Knoot flags ATS-breaking resume issues before a recruiter opens the file",
  "Plot twist: the Talent Pool keeps working while you sleep—recruiters find you",
] as const;
